import styled from 'styled-components';

import { createVar, sizeUp, vars } from '~/theme';
import { headerVars } from '~organisms/Header';

const _maxContentWidth = createVar('_layout-maxContentWidth');

export const Container = styled.div(({ theme }) => ({
  ...vars({
    [headerVars.paddingInline]: sizeUp('35rem', ['md', '60rem']),
    [headerVars.logoHeight]: '72rem',
    [headerVars.navHeight]: '67rem',
    [headerVars.headerHeight]: `calc(${headerVars.logoHeight} + ${headerVars.navHeight})`,
    [_maxContentWidth]: theme.breakpoint.screen.xl,
  }),

  minInlineSize: '300rem',
  marginInline: 'auto',
  minHeight: '100vh',
  boxShadow: '0 -10rem 25rem -12rem gray, inset 0rem 10rem 10rem -3rem gray',

  fontFamily: theme.typography.family.arial,
}));

export const MainContent = styled.main(() => ({
  position: 'relative',

  maxInlineSize: _maxContentWidth,
  blockSize: '100%',
  paddingInline: headerVars.paddingInline,
  paddingBlock: '30rem 100rem',
  marginInline: 'auto',
  overflow: 'hidden',
}));

export const NextStepContainer = styled.div(({ theme }) => ({
  position: 'fixed',
  // 139rem it would be at the very start, connected to navbar, 30px is the padding top of main layout
  insetBlockStart: '169rem',
  insetInlineEnd: sizeUp(headerVars.paddingInline, [
    'md',
    `calc(((100% - ${_maxContentWidth}) / 2) + ${headerVars.paddingInline})`,
  ]),
  zIndex: theme.overlayPosition.layerImportant,

  borderRadius: '20rem',
  backgroundColor: 'white',
}));
